// extracted by mini-css-extract-plugin
export default {"wrapper":"FAQ_wrapper__DMoi6","faqs":"FAQ_faqs__JEDI0","Cat_playing":"FAQ_Cat_playing__8yM-9"};